exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel-pagination {\n  margin-top: -50px;\n}\n", ""]);

// exports
